const LayoutDefault = () =>
  import(/* webpackChunkName: "mitra-usaha" */ '@/layouts/LayoutDefault.vue');

const Dashboard = () =>
  import(
    /* webpackChunkName: "mitra-usaha" */ '@/views/member/cashbill/Index.vue'
  );
const Cashbill = () =>
  import(
    /* webpackChunkName: "mitra-usaha" */ '@/views/member/cashbill/Cashbill.vue'
  );

let root = '/cashbill';

export default [
  {
    path: root + '/',
    component: Dashboard,
    name: 'cashbill',
    meta: {
      auth: true,
      title: 'Dashboard',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/cashbill',
    component: Cashbill,
    meta: {
      auth: true,
      title: 'Cashbill',
      layout: LayoutDefault,
      layoutProps: {
        disableBreadcrumb: true
      }
    },
  }
];
